import React from 'react';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import Overlay from 'components/Overlay';
import ListEvent from 'components/ListEvent';
import Content from 'components/Content';
import Event from 'components/Event';
import 'style/main.less';
import Helmet from 'react-helmet';
import { config } from 'config';
import image from './GCAPP.png';
import { filter, find } from 'lodash';
import ResponsiveImage from 'components/ResponsiveImage';
import Frame from 'components/Frame';

import style from './style.module.less';

const SIDEBAR_SIZES = '(min-width: 800px) 300px, 100vw';

const sidebar = (
    <div>
        <ResponsiveImage sizes={SIDEBAR_SIZES} className={style.sidebar_image} source="termine/Lokalrunde22" />
        <ResponsiveImage sizes={SIDEBAR_SIZES} className={style.sidebar_image} source="termine/brennholzverleih" />
        <ResponsiveImage sizes={SIDEBAR_SIZES} className={style.sidebar_image} source="termine/Sema" />
        <ResponsiveImage sizes={SIDEBAR_SIZES} className={style.sidebar_image} source="termine/vercetti" />
        <ResponsiveImage sizes={SIDEBAR_SIZES} className={style.sidebar_image} source="termine/truecolors" />
        <ResponsiveImage sizes={SIDEBAR_SIZES} className={style.sidebar_image} source="termine/Velvetone" />
        <ResponsiveImage sizes={SIDEBAR_SIZES} className={style.sidebar_image} source="termine/nappy" />
    </div>
);

export default function Template({ children, route }) {
    const isProgrammRoot = children.props.route.page.path === '/programm/';
    const events = route.childRoutes;

    return (
        <Content sidebar={sidebar}>
            <Helmet title={config.siteTitle} />
            {isProgrammRoot
                ? children
                : <EventOverlay pages={children.props.route.pages} data={children.props.route.page.data} />}
            <h1>Hier ein Rückblick auf das Programm im Golden City</h1>
            <a href="/docs/GC_PROGRAMM_2019_MAIJUNI.pdf">Programm 2019 MAI / JUNI als PDF</a><br></br>
            <a href="/docs/GC_PROGRAMM_JULIAUGUST.pdf">Programm 2019 JULI / AUGUST als PDF</a><br></br>
            <a href="/docs/GC_PROGRAMM_JULI_2021">Programm Juli 2021 als PDF</a><br></br>
            <a href="/docs/GC_PROGRAMM_AUGSEPT_2021">Programm August / September 2021 als PDF</a><br></br>
            <a href="/docs/GC_PROGRAMM_2022_WEB.pdf">Programm Juli 2022 als PDF</a><br></br>
            <a href="/docs/GC_PROGRAMM_2022_2_WEB.pdf">Programm August/September 2022 als PDF</a><br></br>
            <ListEvent events={events} />
        </Content>
    );
}

function EventOverlay({ pages, data }) {
    const otherEvents =
        data.eventType &&
        filter(pages, page => {
            if (Array.isArray(data.eventType)) {
                const array1 = data.eventType;
                if (Array.isArray(page.data.eventType)) {
                    const array2 = page.data.eventType;
                    for (let foo in array1) {
                        if (array2.indexOf(foo) !== 1) {
                            return true;
                        }
                    }
                    return false;
                } else {
                    return array1.indexOf(page.data.eventType) !== -1;
                }
                return false;
            } else {
                return page.data.eventType === data.eventType;
            }
        });

    const projects =
        data.eventType &&
        filter(
            pages,
            page => page.data.category === data.eventType || data.eventType.indexOf(page.data.category) !== -1
        );

    return (
        <Overlay backLink="/programm/">
            <Event projects={projects} otherEvents={otherEvents} {...data} />
        </Overlay>
    );
}



// WEBPACK FOOTER //
// ./programm/_template.js